export default __webpack_public_path__ + "static/media/arma3.535fbb25.jpeg";